import { OreButton, OreCardContainer, OreCardWrapper, OreDivider, OreStack } from "@edenredespana/oreneta"
import { FormProvider } from "react-hook-form"
import { OtpForm, useLoginController } from "../hooks"
import { useLocation, useNavigate } from "react-router-dom"
import { navigationRoutes, openNavigationRoutes } from "@/Shared/ui/routers"
import { formTranslation } from "@/Shared/ui/sharedTranslation"
import { useTranslation } from "react-i18next"
import { useLoader } from "@/Shared/ui/loader"
import { useRateLimitedCountdown } from "@/Shared/ui/hooks"
import { HttpMethod } from "@/Shared/domain"
import { resendOtpCode } from "@/Shared/infrastructure/endpoints"
import { CreateAccountOtpForm } from "./CreateAccountOtpForm"
import { createLoginRepository } from "@/Account/infrastructure/ApiLoginRepository"

export const RegisterStepThree = (): JSX.Element => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const navigate = useNavigate()
  const { startLoading, stopLoading } = useLoader()
  const { otpForm, validateOtp, resendOtp } = useLoginController(createLoginRepository(),state?.otpGuid ?? '')
  const { formState: { isValid } } = otpForm

  const {
    formattedMessage,
    startCountdown,
    isBlocked,
  } = useRateLimitedCountdown({
    messageTemplate: t(formTranslation.common.retryBlockMessage),
    params: {
      endpointRoute: `/${resendOtpCode}`,
      endpointActionName: HttpMethod.POST
    }
  })

  const handleSubmit = async (formData: OtpForm): Promise<void> => {
    startLoading()
    const response = await validateOtp(formData.otp)
    stopLoading()

    if (!response) {
      otpForm.setError('otp', {
        type: 'manual',
        message: t(formTranslation.errors.invalidCode)
      })
    } else {
      window.location.href = navigationRoutes.home
    }
  }

  const handleOtpResend = async (): Promise<void> => {
    await resendOtp()
    startCountdown()
  }

  return (
    <>
      <FormProvider {...otpForm}>
        <form>
          <OreCardContainer>
            <OreCardWrapper>
              <OreStack space="2xlarge" placeContent="stretch">
                <CreateAccountOtpForm isBlocked={isBlocked} errorMessage={formattedMessage} handleOtpResend={handleOtpResend} />
              </OreStack>
            </OreCardWrapper>
          </OreCardContainer>

          <OreDivider space="medium" />
          <OreStack direction="row" placeContent="end" space="medium">
            <OreButton
              onClick={() => navigate(openNavigationRoutes.login)}
              size="small"
              category="secondary"
              data-testid="cancel"
            >
              {t(formTranslation.common.buttons.cancel)}
            </OreButton>
            <OreButton
              disabled={!isValid}
              type="submit"
              onClick={otpForm.handleSubmit(handleSubmit)}
              size="small"
              category="primary"
              data-testid="signUp"
            >
              {t(formTranslation.common.buttons.continue)}
            </OreButton>
          </OreStack>
        </form>
      </FormProvider>
    </>
  )
}